import React from 'react'

import { EuiButton, EuiButtonEmpty, EuiModal, EuiModalBody, EuiModalFooter, EuiModalHeader, EuiModalHeaderTitle, EuiText } from '@elastic/eui'

interface ApproveWithUnsavedChangesModalProps {
  canSave: boolean
  isSaving: boolean
  onCancel: () => void
  onApproveWithoutSaving: () => void
  onSaveAndApprove: () => void
}

export const ApproveWithUnsavedChangesModal: React.FC<ApproveWithUnsavedChangesModalProps> = ({ canSave, isSaving, onCancel, onApproveWithoutSaving, onSaveAndApprove }) => {
  return (
    <EuiModal onClose={onCancel}>
      <EuiModalHeader>
        <EuiModalHeaderTitle>Save changes before approving?</EuiModalHeaderTitle>
      </EuiModalHeader>
      <EuiModalBody>
        <EuiText>
          <p>This campaign has unsaved changes. Approving without saving will discard them.</p>
        </EuiText>
      </EuiModalBody>
      <EuiModalFooter>
        <EuiButtonEmpty onClick={onCancel} disabled={isSaving}>
          Cancel
        </EuiButtonEmpty>
        <EuiButton color='warning' onClick={onApproveWithoutSaving} disabled={isSaving}>
          Approve without saving
        </EuiButton>
        <EuiButton fill onClick={onSaveAndApprove} disabled={!canSave} isLoading={isSaving}>
          Save and approve
        </EuiButton>
      </EuiModalFooter>
    </EuiModal>
  )
}
